import { render, staticRenderFns } from "./EditarProgramacao.vue?vue&type=template&id=4fcbf080"
import script from "./EditarProgramacao.vue?vue&type=script&lang=ts"
export * from "./EditarProgramacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports